import { render, staticRenderFns } from "./PatientModalFreemiumExtensionConfirm.vue?vue&type=template&id=5834dcab"
import script from "./PatientModalFreemiumExtensionConfirm.vue?vue&type=script&lang=js"
export * from "./PatientModalFreemiumExtensionConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports